/** Include zero and every observed value, with headroom for the endpoint label. No fixed ceiling. */
export function dailyMarginDomain([min, max]: [number, number]): [number, number] {
  const low = Math.min(0, min);
  const high = Math.max(0, max);
  const padding = Math.max((high - low) * 0.12, 1);
  return [low < 0 ? low - padding : 0, high + padding];
}
